import moment, {MomentInput} from 'moment-timezone'

export const adjustEnLocale = (language: string): string => (language === 'en' ? 'en-GB' : language)

export interface Timespan<T = string> {
  start: T
  end: T
}

export const iso8601Min = (d1: string, d2: string): string => (d1 <= d2 ? d1 : d2)

type SplitIntoIntervals = (
  start: MomentInput,
  end: MomentInput,
  intervalLength: number
) => Timespan<string>[]

/**
 * Takes a timespan and splits it up into multiple intervals with given length.
 *
 * @returns ISO8601 formatted start/end strings
 * @param start
 * @param end
 * @param intervalLength Length of the interval in minutes.
 */
export const splitToIntervals: SplitIntoIntervals = (start, end, intervalLength) => {
  const slots = [] as Timespan<string>[]

  const current = moment.utc(start)
  const endString = moment.utc(end).toISOString()

  while (current.isBefore(end)) {
    const s = moment.utc(current).toISOString()
    current.add(intervalLength, 'minutes')
    const e = iso8601Min(current.toISOString(), endString)
    slots.push({start: s, end: e})
  }

  return slots
}
